import { Injectable } from '@angular/core';
import { IEnviroment } from '../interfaces/ienviroment';

@Injectable()
export class TransferEnviromentService {
  public enviroment: IEnviroment = {};

  public getEnviroment(): IEnviroment {
    return this.enviroment;
  }

  public getToken(): string {
    return '';
  }
}
